module.exports = __webpack_public_path__ + "img/curated-img.8065edec.svg";